import { string } from 'yup';

function inlineEmailValidation (inputEmails, params) {

	const emails = inputEmails.split(/[,]+/).filter(Boolean);
	const filter =		/^([\w-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
	let count = 0;

	for (let i = 0; i < emails.length; i++) {

		const email = emails[i].trim();
		if (email !== '') {

			count++;

			if (!filter.test(email)) {

				return {
					valid: false,
					error: 'Please enter a valid email address.'
				};

			}

			if (email.length > params.maxLengthPerEmail) {

				return {
					valid: false,
					error: `Please enter no more than ${params.maxLengthPerEmail} characters for each email address.`
				};

			}

		}

	}

	if (count > params.maxTotalEmailCount) {

		return {
			valid: false,
			error: `Cannot enter more than ${params.maxTotalEmailCount} emails.`
		};

	}

	return { valid: true };

}

const rule = {
	name: 'inlineEmails',
	method (
		{ message, maxTotalEmailCount, maxLengthPerEmail } = {
			message: 'Please enter a valid email address.',
			maxTotalEmailCount: 3,
			maxLengthPerEmail: 50
		}
	) {

		return this.test('inlineEmails', message, function (value) {

			const { valid, error } = inlineEmailValidation(value, { maxTotalEmailCount, maxLengthPerEmail });
			const { createError } = this;
			return valid || createError({ error });

		});

	},
	schemaType: string
};

export default rule;
